module.exports = require("core-js-pure/stable/instance/reduce");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/instance/reduce.js
// module id = 596
// module chunks = 0